<template>
  <div>
    <page-header :title="$t('bill.suggestsy_overview')" />
    <page-body>
      <a-radio-group v-model="time" class="mb-3">
        <a-radio-button v-for="item of timeOpts" :value="item.key" :key="item.key">
          {{ item.label }}
        </a-radio-button>
      </a-radio-group>
      <div :class="isTemplate ? '' : 'd-flex'">
        <rule-overview :data="data.enable_rules || {}" :is-template="isTemplate" />
        <suggest-overview :data="data" :suggest-list="suggestList" :time="time" :is-template="isTemplate" />
      </div>
      <suggest-analysis ref="analysis" :time-params="timeParams" :data="data" :is-template="isTemplate" :template-params="templateParams" />
    </page-body>
  </div>
</template>

<script>
import RuleOverview from './components/RuleOverview'
import SuggestOverview from './components/SuggestOverview'
import SuggestAnalysis from './components/SuggestAnalysis'

export default {
  name: 'SuggestsOverview',
  components: {
    RuleOverview,
    SuggestOverview,
    SuggestAnalysis,
  },
  props: {
    isTemplate: {
      type: Boolean,
      default: false,
    },
    templateParams: {
      type: Object,
      default: () => ({}),
    },
    defaultProjectId: {
      type: String,
      default: undefined,
    },
    defaultDomainId: {
      type: String,
      default: undefined,
    },
  },
  data () {
    return {
      timeOpts: [
        { key: 'month', label: this.$t('common.date_time.month') },
        { key: 'last_month', label: this.$t('common.date_time.last_month') },
        { key: 'year', label: this.$t('common.date_time.year') },
      ],
      time: this.templateParams.time || 'month',
      data: {},
      suggestList: [],
    }
  },
  computed: {
    timeParams () {
      const ret = {}
      if (this.time === 'month') {
        ret.start = Number(this.$moment().startOf('month').format('YYYYMM'))
        ret.end = Number(this.$moment().endOf('month').format('YYYYMM'))
      } else if (this.time === 'last_month') {
        ret.start = Number(this.$moment().subtract(1, 'month').startOf('month').format('YYYYMM'))
        ret.end = Number(this.$moment().subtract(1, 'month').endOf('month').format('YYYYMM'))
      } else if (this.time === 'year') {
        ret.start = Number(this.$moment().startOf('year').format('YYYYMM'))
        ret.end = Number(this.$moment().endOf('year').format('YYYYMM'))
      }
      return ret
    },
    params () {
      const ret = { ...this.timeParams }
      if (this.$store.getters.isDomainMode) {
        ret.domain_id = this.$store.getters.userInfo.projectDomainId
      }
      if (this.$store.getters.isProjectMode) {
        ret.project_id = this.$store.getters.userInfo.projectId
      }
      if (this.defaultProjectId) {
        ret.project_id = this.defaultProjectId
      }
      if (this.defaultDomainId) {
        ret.domain_id = this.defaultDomainId
      }
      return ret
    },
  },
  watch: {
    params: {
      handler () {
        this.fetchSuggestOverview()
      },
      deep: true,
    },
  },
  created () {
    this.$rM = new this.$Manager('suggestsysalerts/overview', 'v1')
    this.$sM = new this.$Manager('suggestsysalerts', 'v1')
    this.fetchSuggestOverview()
    this.fetchSuggestAlert()
  },
  methods: {
    async fetchSuggestOverview () {
      try {
        const res = await this.$rM.list({ params: this.params })
        this.data = res.data
      } catch (err) {
        throw err
      }
    },
    async fetchSuggestAlert () {
      try {
        const res = await this.$sM.list({ params: { scope: this.$store.getters.scope, limit: 5, $t: 1 } })
        this.suggestList = res.data.data || []
      } catch (err) {
        throw err
      }
    },
    getTemplateParams () {
      const analysisParams = this.$refs.analysis.getTemplateParams()
      return {
        time: this.time,
        ...analysisParams,
      }
    },
  },
}
</script>

<style lang="less" scoped>
.overview-card {
  flex: 1;
  border: solid 1px #e8e8e8;
  border-radius: 3px;
  height: 300px;
}
</style>
